/**
 * Synthèse PageSpeed de secours (plans générés avant le champ pagespeed_summary).
 */
export function buildPagespeedSummaryFallback(perf) {
  if (!perf || !(Number(perf.pagespeed_average) > 0)) return '';
  const avg = Math.round(Number(perf.pagespeed_average) || 0);
  const mobile = Math.round(Number(perf.pagespeed_performance_mobile) || 0);
  const desktop = Math.round(Number(perf.pagespeed_performance_desktop) || 0);
  const a11y = Math.round(Number(perf.pagespeed_accessibility) || 0);
  const bp = Math.round(Number(perf.pagespeed_best_practices) || 0);
  const seoLh = Math.round(Number(perf.pagespeed_seo) || 0);
  return (
    `Le rapport Google PageSpeed indique une performance globale de ${avg}/100 `
    + `(mobile ${mobile}/100, desktop ${desktop}/100). `
    + `Accessibilité ${a11y}/100, bonnes pratiques ${bp}/100, critères SEO Lighthouse ${seoLh}/100. `
    + `Le détail des métriques et des audits en échec figure ci-dessous.`
  );
}
